<template>
  <div id="helper" class="container-fluid">
    <div class="row">
      <div class="col-md-4" v-for="tool in tools" :key="tool.id">
        <div class="tool-btn" @click="modal(tool.modalName)">
          <div class="name">{{ tool.name }}</div>
          <div class="desc">{{ tool.des }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Helper',
  data () {
    return {
      loading: false,
      tools: [
        {
          id: 'PassportUnlock',
          name: '用户解禁',
          des: '兆配云封禁解禁立即生效',
          modalName: 'PassportUnlockModal'
        },
        {
          id: 'EpcOrderPay',
          name: '服务订单收款',
          des: 'EPC服务订单标记收款',
          modalName: 'EpcOrderPayModal'
        }
      ]
    }
  }
}
</script>

<style lang="stylus">
#helper
  .tool-btn
    border 1px solid #d4d4d4
    margin: 8px
    height: 100px
    padding 8px
    cursor pointer
    background #fff
    display flex
    overflow hidden
    flex-direction column
    justify-content: center
    >.name
      text-align center
      font-size 16px
      font-weight bold
    >.desc
      max-height 44px
      line-height 22px
      -webkit-line-clamp: 2
      text-align center
      margin-top 8px
      color #9c9c9c
      overflow hidden
      text-overflow ellipsis
      word-break break-word
    &:hover, &:focus
      border-color #077fd2
      background #fcfcfc
</style>
